<div class="language-switcher">
    <a *ngFor="let language of languages" (click)="onChangeLanguages(language.translationFile)" [ngClass]="{'active':translate.currentLang == language.translationFile || (!translate.currentLang && language.translationFile=='en')}">{{language.languageNative}}</a>
  </div>